import { Route, Routes, BrowserRouter } from "react-router-dom";
import HOME from "./PAGES/Home";
import STORE from "./PAGES/Store";
import CATEGORY from "./PAGES/Category";
import ABOUT from "./PAGES/About";
import CONTACT from "./PAGES/Contact";
import PRODUCT from "./PAGES/Product";
import NotFound from "./PAGES/NotFound";
import SEARCH from "./PAGES/Search";
import { Provider} from 'react-redux';
import store from './store/store';
import PrivacyPolicy from "./PAGES/PrivacyPolicy";

function App() {

  return (
    <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HOME />} />
        <Route path="/:name" element={<STORE />} />
        <Route path="/:name/contact" element={<CONTACT />} />
        <Route path="/:name/about" element={<ABOUT />} />
        <Route path="/:name/category/:category_name/:id" element={<CATEGORY />} />
        <Route path="/:name/product/:product_name/:id" element={<PRODUCT />} />
        <Route path="/:name/search" element={< SEARCH/>} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    </Provider>
  );
}

export default App;
